<template>
  <div class="ts-upload">
    <Upload
      ref="upload"
      v-bind="$attrs"
      v-on="$listeners"
      :file-list="value"
      :show-file-list="false"
      :on-change="handleFileUploadChange"
      :on-success="handleFileUploadSuccess"
    >
      <slot></slot>
    </Upload>
    <div class="files">
      <div v-for="(file, i) in value" :key="i" class="file">
        <div class="info">
          <p class="filename">{{ file.name }}</p>
          <ts-button size="mini" circle @click="handleFileRemoveClick(file)">
            <XMark />
          </ts-button>
        </div>
        <div v-if="file.status === 'uploading'" class="progress">
          <ts-progress :percentage="file.percentage"></ts-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ts-upload::v-deep {
  margin: 12px 0;

  .files {
    margin-top: 12px;
  }

  .file {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    border-radius: 20px;
    font-size: 12px;
    padding: 6px 12px;
    margin: 6px 0;
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .filename {
      flex-grow: 1;

      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }

    .progress {
      margin-top: 4px;
    }
  }
}
</style>

<script>
import { Upload } from 'element-ui';

import XMark from '../../assets/x-mark.svg';

export default {
  name: 'TsUpload',
  components: {
    Upload,
    XMark
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleFileUploadChange(file, files) {
      this.$emit('input', files);
    },
    handleFileUploadSuccess(response, file) {
      file.id = response.data.id;
    },
    handleFileRemoveClick(file) {
      this.$refs.upload.abort(file);
      this.$emit(
        'input',
        this.value.filter(f => f.uid !== file.uid)
      );
    }
  }
};
</script>
